import React from "react";
import { cn } from "../../lib/utils";
import { Message } from "./AssistantContext";

interface MessageBubbleProps {
  message: Message;
  isLastInGroup: boolean;
  renderMarkdown: (text: string) => React.ReactNode;
  renderMessageWithMentions: (text: string) => React.ReactNode;
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({
  message,
  isLastInGroup,
  renderMarkdown,
  renderMessageWithMentions
}) => {
  return (
    <div className={cn(
      "flex",
      message.role === "assistant" ? "justify-start" : "justify-end"
    )}>
      <div className={cn(
        "flex flex-col max-w-[85%] min-w-0",
        message.role === "assistant" ? "items-start" : "items-end ml-auto"
      )}>
        <div className="relative group w-full">
          {/* Bubble tail - only on last message of group */}
          {isLastInGroup && message.role !== "assistant" && (
            <div className="absolute -right-1 bottom-2 w-3 h-3 bg-maitai-green transform rotate-45 rounded-br-sm" />
          )}
          
          {/* Message bubble */}
          <div 
            className={cn(
              "relative px-4 py-2.5 shadow-sm",
              message.role === "assistant" 
                ? "bg-muted text-foreground rounded-2xl" 
                : cn(
                    "bg-maitai-green text-white",
                    isLastInGroup
                      ? "rounded-2xl rounded-br-sm"
                      : "rounded-2xl"
                  )
            )}
            style={{ wordBreak: "break-word", overflowWrap: "break-word" }}
          >
            {message.role === "assistant" ? (
              renderMarkdown(message.content)
            ) : (
              <p className="text-sm leading-relaxed whitespace-pre-wrap">
                {renderMessageWithMentions(message.content)}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
